import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { deletepayslip, listpayslips, updatepayslipstatus } from "../../../services/admin";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import exportUrl from "../../../exportUrl";
import { isAdmin } from "../../../utils/roles";

export default function AllPayslip() {
    const [filterProduct, setFilterProduct] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetchPayslips();
    }, []);

    const fetchPayslips = () => {
        const branchId = localStorage.getItem("branch");
        listpayslips(branchId).then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data.details);
            }
        });
    };

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 180,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        {isAdmin() && (
                            <>
                                <a
                                    onClick={() => navigate(`/payslip/editpayslip/${params.value}`)}
                                    className="btn-sm btn-info me-2"
                                    title="Edit Payslip"
                                >
                                    <i className="fa fa-edit"></i>
                                </a>
                                <a
                                    onClick={() => handleDelete(params.value)}
                                    className="btn-sm btn-danger me-2"
                                    title="Delete Payslip"
                                >
                                    <i className="fa fa-trash"></i>
                                </a>
                            </>
                        )}
                        <a
                            onClick={() => handleViewPDF(params.value)}
                            className="btn-sm btn-success me-2"
                            title="View PDF"
                        >
                            <i className="fa fa-file-pdf-o"></i>
                        </a>
                        {params.data.status === "generated" && isAdmin() && (
                            <a
                                onClick={() => handleMarkAsPaid(params.value)}
                                className="btn-sm btn-primary me-2"
                                title="Mark as Paid"
                            >
                                <i className="fa fa-check"></i>
                            </a>
                        )}
                    </div>
                );
            },
        },
        {
            headerName: "Staff Name",
            field: "staff_name",
            width: 200,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Staff Code",
            field: "staff_code",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Month",
            field: "month",
            width: 120,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Year",
            field: "year",
            width: 100,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Basic Salary",
            field: "basic_salary",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "right" },
            cellRenderer: function (params) {
                return params.value ? parseFloat(params.value).toFixed(2) : "0.00";
            },
        },
        {
            headerName: "Gross Salary",
            field: "gross_salary",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "right" },
            cellRenderer: function (params) {
                return params.value ? parseFloat(params.value).toFixed(2) : "0.00";
            },
        },
        {
            headerName: "Total Deductions",
            field: "total_deductions",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "right" },
            cellRenderer: function (params) {
                return params.value ? parseFloat(params.value).toFixed(2) : "0.00";
            },
        },
        {
            headerName: "Net Salary",
            field: "net_salary",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "right" },
            cellRenderer: function (params) {
                return params.value ? parseFloat(params.value).toFixed(2) : "0.00";
            },
        },
        {
            headerName: "Status",
            field: "status",
            width: 120,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => (
                params.value === "paid"
                    ? <span className="badge bg-success">Paid</span>
                    : <span className="badge bg-warning">Generated</span>
            ),
        },
        {
            headerName: "Payment Date",
            field: "payment_date",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return moment(params.value).format("DD-MM-YYYY");
                }
                return "-";
            },
        },
        {
            headerName: "Created Date",
            field: "created_at",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return moment(params.value).format("DD-MM-YYYY");
                }
            },
        },
    ];

    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this payslip?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                deletepayslip(id).then((res) => {
                    if (res.status === true) {
                        toast.success(res.message);
                        fetchPayslips();
                    }
                });
            }
        });
    };

    const handleMarkAsPaid = (id) => {
        Swal.fire({
            title: "Mark as Paid?",
            text: "Are you sure you want to mark this payslip as paid?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, mark as paid!",
        }).then((result) => {
            if (result.isConfirmed) {
                const data = {
                    status: "paid",
                };
                updatepayslipstatus(id, data).then((res) => {
                    if (res.status === true) {
                        toast.success(res.message);
                        fetchPayslips();
                    }
                });
            }
        });
    };

    const handleViewPDF = (id) => {
        // Trigger a direct download instead of opening a new tab. The backend
        // sends the PDF as an attachment, so the browser saves it.
        const link = document.createElement("a");
        link.href = `${exportUrl}api/payslippdf/${id}`;
        link.setAttribute("download", `payslip_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">All Payslips</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Payslip</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        All Payslips
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-6">
                                            <h4 className="card-title">All Payslips</h4>
                                        </div>
                                        <div className="col-6 text-end">
                                            {isAdmin() && (
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={() => navigate("/payslip/addpayslip")}
                                                >
                                                    <i className="fa fa-plus"></i> Generate Payslip
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                            <div className="ag-theme-alpine" style={{ height: 600, width: "100%" }}>
                                <AgGridReact
                                    rowData={filterProduct}
                                    columnDefs={columnDefs}
                                    defaultColDef={{
                                        sortable: true,
                                        resizable: true,
                                    }}
                                    pagination={true}
                                    paginationPageSize={20}
                                />
                            </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
